import RouteFAQs from "./RouteFAQs";
import {Link, useParams} from 'react-router-dom';
import routesData from './routes.json';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretLeft} from "@fortawesome/free-solid-svg-icons";

/*const routePage = {
  "duration": "2",
  "title": "De Marrakech al Desierto de Zagora",
  "departure": "Marrakech",
  "arrival": "Marrakech",
  "description": [
    "El primer día comenzará en Marrakech, donde el guía recogerá a los turistas y los llevará en coche a través del Atlas hacia Ouarzazate. En el camino, se recorrerá el Valle del Draa y se verán kasbahs y huertas trabajadas por los aldeanos. Luego se llegará a Zagora, desde donde se irá a un campamento de jaimas en el corazón del desierto a lomos de dromedarios, donde se disfrutará de la puesta de sol, la cena y el descanso nocturno bajo las estrellas.",
    "El segundo día comenzará con el amanecer en el desierto y un desayuno en el campamento de jaimas. Después, se regresará a Marrakech en coche y se visitará la kasbah de Taourirt y las kasbahs de Ait Ben Haddou y Telouet. Finalmente, se completará el recorrido atravesando las montañas del Atlas y se llegará a Marrakech, donde concluirá la excursión."
  ]
}*/

export default function RoutePage() {

  const { routeDeparture, routeName, routeIndex } = useParams();

  let routeData = getRoute(routeDeparture, routeIndex);

  document.title = "Sentir Marruecos | Ruta: " + routeData.title;
  window.scrollTo({ top: 0, left: 0});

  let imgSrc = "/home/heroHome-" + (Math.floor(Math.random() * 10) + 1) + ".JPG";

  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-4 lg:sticky top-32">
            <Link to={"/rutas"}>
              <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-lg inline-flex items-center mb-5">
                <FontAwesomeIcon icon={faCaretLeft} />
                <span className={"ml-3"}>Rutas</span>
              </button>
            </Link>
            <p className="text-base font-semibold leading-7 text-orange-600">
              Desde {routeData.departure}
            </p>
            <div className="text-base leading-7 text-gray-700 lg:max-w-lg mb-12">
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                {routeData.title}
              </h1>
              <dl className="mt-10 grid grid-cols-2 gap-8 border-y border-gray-900/10 py-4 sm:grid-cols-3">
                <div key={0}>
                  <dt className="text-sm font-semibold leading-6 text-gray-500">
                    Salida
                  </dt>
                  <dd className="text-2xl font-bold leading-10 tracking-tight text-gray-900">
                    {routeData.departure}
                  </dd>
                </div>
                <div key={1}>
                  <dt className="text-sm font-semibold leading-6 text-gray-500">
                    Llegada
                  </dt>
                  <dd className="text-2xl font-bold leading-10 tracking-tight text-gray-900">
                    {routeData.arrival}
                  </dd>
                </div>
                <div key={2}>
                  <dt className="text-sm font-semibold leading-6 text-gray-500">
                    Duración
                  </dt>
                  <dd className="text-2xl font-bold leading-10 tracking-tight text-gray-900">
                    {routeData.duration} {(Number(routeData.duration) > 1) ? " días" : "día"}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="relative overflow-hidden rounded-3xl bg-gray-900 px-6 pb-9 pt-64 shadow-2xl sm:px-12 lg:max-w-lg lg:px-8 lg:pb-8 xl:px-10 xl:pb-10">
              <img
                className="absolute inset-0 h-full w-full object-cover brightness-125 saturate-50"
                src={imgSrc}
                alt=""
              />
              <div className="absolute inset-0 bg-gray-900 mix-blend-multiply opacity-60"/>
              <div
                className="absolute left-1/2 top-1/2 -ml-16 -translate-x-1/2 -translate-y-1/2 transform-gpu blur-3xl"
                aria-hidden="true"
              >
                <div
                  className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-orange-400 to-gray-600 opacity-40"
                  style={{
                    clipPath:
                      "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                  }}
                />
              </div>
              <figure className="relative isolate">
                <svg
                  viewBox="0 0 162 128"
                  fill="none"
                  aria-hidden="true"
                  className="absolute -left-2 -top-4 -z-10 h-32 stroke-white/20"
                >
                  <path
                    id="0ef284b8-28c2-426e-9442-8655d393522e"
                    d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                  />
                  <use href="#0ef284b8-28c2-426e-9442-8655d393522e" x={86} />
                </svg>
                <blockquote className="mt-6 text-xl font-semibold leading-8 text-white pt-24">
                  <p>
                    “{routeData.title}”
                  </p>
                </blockquote>
                <figcaption className="mt-6 text-sm leading-6 text-gray-200">
                  <strong className="font-semibold text-white">
                    Salem Aghdaoui,
                  </strong>{" "}
                  Gerente de Sentir Marruecos
                </figcaption>
              </figure>
            </div>
          </div>
          <div>
            <div className="text-base leading-7 text-gray-700 lg:max-w-lg">
              <div className="max-w-xl">
                {routeData.description.map((dayDescription, index) => {
                  return <>
                    <span className="mt-8 inline-flex items-center gap-x-1.5 rounded-md bg-orange-600/10 px-1.5 py-0.5 font-medium text-orange-600">
                      <svg className="h-1.5 w-1.5 fill-orange-600" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx={3} cy={3} r={3} />
                      </svg>
                      Día {index + 1}
                    </span>
                    <p className={"mt-1"}>{dayDescription}</p>
                  </>;
                })}
              </div>
            </div>
          </div>
        </div>
        {/*<hr className="my-20 sm:my-24 h-0.5 border-t-0 bg-gray-300 opacity-100"/>
        <RouteFAQs />*/}
      </div>
    </div>
  );
}

function getRoute(routeDeparture: string | undefined, index: string | undefined): RouteOption {


  let departureIndex;

  switch (routeDeparture) {
    case "desde-marrakech":
      departureIndex = 0;
      break;
    case "desde-tanger":
      departureIndex = 1;
      break;
    case "desde-fez":
      departureIndex = 2;
      break;
    case "desde-casablanca":
      departureIndex = 3;
      break;
    case "desde-ceuta":
      departureIndex = 4;
      break;
    default:
      departureIndex = null;
      break;
  }

  let routeIndex = Number(index);

  if (departureIndex !== null && routeIndex !== null) {
    let route = routesData.routes[departureIndex].options[routeIndex];
    return {
      title: route.title,
      duration: Number(route.duration),
      departure: route.departure,
      arrival: route.arrival,
      description: route.description,
    };
  }

  return {
    title: "",
    duration: 0,
    departure: "",
    arrival: "",
    description: [],
  };
}

interface RouteOption {
  title: string;
  duration: number;
  departure: string;
  arrival: string;
  description: string[];
}
